import React from 'react'
import './Record.css'
import PropTypes from 'prop-types'

function RecordManager(props) {
  const { records, goToSpecificPage } = props

  let recordManagerMarkup =
    records.length > 0 ? (
      <div className='record-container '>
        <p className='no-select record-title'>Records</p>
        <div className='record-table'>
          <table>
            <thead>
              <tr>
                <th>Page</th>
                <th>Image</th>
                <th>Textbox</th>
                <th>Signature</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record, index) => {
                return (
                  <tr key={index} onClick={() => goToSpecificPage(record.page)}>
                    <td>{record.page}</td>
                    <td>{record.image}</td>
                    <td>{record.textbox}</td>
                    <td>{record.signature}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    ) : (
      <p className='no-select record-placeholder'>You do not have any record now.</p>
    )
  return recordManagerMarkup
}

RecordManager.propTypes = {
  records: PropTypes.arrayOf(PropTypes.object).isRequired,
  goToSpecificPage: PropTypes.func.isRequired,
}

export default RecordManager
